import type { DashboardPeriod } from "../types";
import { cn } from "../../../lib/utils";
import { useLocale } from "../../../context/LanguageContext";

interface PeriodSelectorProps {
  value: DashboardPeriod;
  onChange: (period: DashboardPeriod) => void;
}

export function PeriodSelector({ value, onChange }: PeriodSelectorProps) {
  const { t } = useLocale();
  const PERIODS: { value: DashboardPeriod; label: string }[] = [
    { value: "WEEK", label: t("dashboard.periodWeek") },
    { value: "MONTH", label: t("dashboard.periodMonth") },
    { value: "QUARTER", label: t("dashboard.periodQuarter") },
  ];

  return (
    <div className="inline-flex rounded-lg border border-border bg-card p-1">
      {PERIODS.map((period) => (
        <button
          key={period.value}
          onClick={() => onChange(period.value)}
          className={cn(
            "rounded-md px-3 py-1.5 text-sm font-medium transition-colors",
            value === period.value
              ? "bg-primary text-white shadow-sm"
              : "text-muted-foreground hover:text-foreground",
          )}
        >
          {period.label}
        </button>
      ))}
    </div>
  );
}
